<!--
 * @LastEditors: chuhongguang
 * @desc: 三维散点图
 * @场景: 重构公式 抽屉 - 最近记录 - 点击对比（三个不同的名称）
-->
<template>
  <div style="text-align: left;">
    <div :id="this.id" :style="{height: '600px', width: '100%'}"></div>
  </div>
</template>
<script>
export default {
  props: ['id', 'serieData', 'serieName'],
  data () {
    return {
      myChart: null,
      option: {}
    }
  },
  mounted () {
    this.drawLine()
  },
  methods: {
    drawLine () {
      // 基于准备好的dom，初始化echarts实例
      if (this.myChart === null) {
        this.myChart = this.$echarts.init(document.getElementById(this.id))
      }
      this.option = {
        tooltip: {
          trigger: 'axis',
          triggerOn: 'click',
          enterable: true,
          extraCssText: 'max-width: 600px; white-space: pre-wrap;'
        },
        toolbox: {
          show: true
        },
        legend: {
        },
        grid3D: {},
        xAxis3D: {
          name: this.serieName[0],
          min: 'dataMin',
          max: 'dataMax'
        },
        yAxis3D: {
          name: this.serieName[1],
          min: 'dataMin',
          max: 'dataMax'
        },
        zAxis3D: {
          name: this.serieName[2],
          min: 'dataMin',
          max: 'dataMax'
        },
        series: [{
          symbolSize: 5,
          color: '#c64743',
          data: this.serieData,
          type: 'scatter3D'
        }],
        dataZoom: [
          {
            show: true,
            type: 'slider',
            fillerColor: 'rgba(167, 183, 204, 0.4)',
            // handleStyle: {
            //   color: '#a7b7cc',
            //   borderColor: '#000'
            // },
            top: '90%'
          }
        ]
      }
      var _this = this
      this.myChart.setOption(this.option)
      window.addEventListener('resize', function () {
        _this.myChart.resize()
        if (_this.myChart) {
          _this.myChart.resize()
        }
      })
    },
    clearData () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.myChart = this.$echarts.init(document.getElementById(this.id))
      this.myChart.clear()
    }
  },
  watch: {
    serieData (newVal, oldVal) {
      this.clearData()
      this.drawLine()
      if (!newVal || newVal.length < 1) {
        return
      }
      this.serieData = newVal
      this.option['series'][0].data = this.serieData
      this.myChart.setOption(this.option)
    },
    id (newVal, oldVal) {
      this.id = newVal
    },
    serieName (newVal, oldVal) {
      this.serieName = newVal
    }
  },
  activated () {
    this.clearData()
  }
}
</script>
<style scoped>
  .el-collapse-item {
    background-color: rgba(255, 255, 255, 0) !important;
  }
  .el-collapse-item__header {
    background-color: rgba(255, 255, 255, 0) !important;
  }
  .el-collapse-item__wrap {
    background-color: rgba(255, 255, 255, 0) !important;
  }
  h4 {
    margin-bottom:0px;
  }
  .bannerTextRed{
    padding: 0 4px;
    line-height: 18px;
    height: 18px;
    border-radius: 4px;
    font-weight: 400;
    background-color:indianred;
    color:white;
    font-size: 13px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dailyBack/scatter3D.vue